// pages/LegalPages/TermsOfUsePage.jsx
import React, { useEffect } from "react";
import {
    LegalPage,
    LegalContainer,
    LegalCard,
    LegalTitle,
    LegalText,
    LegalSectionTitle,
    LegalLink,
    LegalEmailLink,
    LegalAddress,
} from "./legal.elements";

export default function TermsOfUsePage() {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);

    return (
        <LegalPage>
            <LegalContainer>
                    <LegalTitle>Clippn.com</LegalTitle>
                    <LegalSectionTitle>Terms of Use</LegalSectionTitle>
                    <LegalText>Last Updated: 06/14/19</LegalText>

                    <LegalText>
                        PLEASE READ THE FOLLOWING TERMS OF USE CAREFULLY BEFORE USING THIS WEBSITE. We have
                        established the following Terms of Use that we require all our visitors to follow
                        when using our site. In these Terms of Use, the words “we” refer to Clippn, Inc.
                        (hereinafter referred to as “Clippn,” “we,” “our,” or “us”), and the phrase “our site”
                        refers to our web site located at{" "}
                        <LegalLink href="https://www.clippn.com" target="_blank" rel="noreferrer">
                            www.clippn.com
                        </LegalLink>
                        .
                    </LegalText>

                    <LegalSectionTitle>Your Agreement</LegalSectionTitle>
                    <LegalText>
                        You understand that by using our site, you are agreeing to be bound by these Terms of
                        Use. Please do not use our site if you do not agree with these Terms of Use. We may
                        change these Terms of Use at any time. Your continued use of our site after we have
                        posted changes to these Terms of Use means that you agree to be bound by the changes,
                        so please check the Terms of Use regularly for any changes.
                    </LegalText>

                    <LegalText>
                        If you wish to apply to become a Clippn Contributor and provide us with footage that we
                        will then distribute to content distributors, then please apply by completing the form
                        located at{" "}
                        <LegalLink
                            href="http://clippn.com/become-a-contributor-today/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            http://clippn.com/become-a-contributor-today/
                        </LegalLink>
                        . We will review your application and determine, in our sole discretion, whether you
                        meet our requirements for becoming a Clippn Contributor. If we decide that you do, you
                        will be required to enter into a Clippn Contributor Agreement with us, which agreement
                        is separate and apart from these Terms of Use.
                    </LegalText>

                    <LegalSectionTitle>Use of Our Site</LegalSectionTitle>
                    <LegalText>
                        You may not use our site for any unlawful purpose, or for any other purpose that is
                        prohibited by these Terms of Use. Also, you may not interfere or attempt to interfere
                        with the proper operation of our site, including through the use of any device,
                        software or routine, or access or attempt to gain access to any data, files or
                        passwords related to our site through hacking, password mining or any other means. We
                        reserve the right, in our sole discretion, to deny you access to our site, or any
                        portion of our site, without notice.
                    </LegalText>

                    <LegalSectionTitle>Communications to Us</LegalSectionTitle>
                    <LegalText>
                        Although we encourage you to e-mail us, we do not want you to, and you should not,
                        e-mail us any content that contains confidential information. With respect to all
                        e-mails you send to us, including but not limited to, feedback, questions, comments,
                        suggestions, and the like, we shall be free to use any ideas, concepts, know-how, or
                        techniques contained in your communications for any purpose whatsoever, including but
                        not limited to, the development, production and marketing of products and services that
                        incorporate such information, without any obligation to pay any fees or other
                        consideration to you.
                    </LegalText>

                    <LegalSectionTitle>Privacy Notice</LegalSectionTitle>
                    <LegalText>
                        Please refer to{" "}
                        <LegalLink href="https://www.clippn.com/privacy" target="_blank" rel="noreferrer">
                            www.clippn.com/privacy
                        </LegalLink>{" "}
                        for a summary of our privacy practices with respect to information that we may collect
                        from you through our site and how we use this information. Our Privacy Notice is
                        incorporated herein by reference.
                    </LegalText>

                    <LegalSectionTitle>Linking and Framing</LegalSectionTitle>
                    <LegalText>
                        You may not place a link to our site on any other web site, or frame our site within
                        another web site, without our prior written permission.
                    </LegalText>

                    <LegalSectionTitle>Intellectual Property Rights in the Site</LegalSectionTitle>
                    <LegalText>
                        Our site contains various information in the form of data, text, graphics, and other
                        materials that belongs to us or our licensors (the “Content”). You acknowledge that our
                        site and various elements contained therein are protected by copyrights, trademarks,
                        trade secrets, patents, or other proprietary rights, and that these worldwide rights
                        are valid and protected in all forms, media, and technologies existing now and
                        hereinafter developed. You also acknowledge that the Content is and shall remain the
                        property of us or our licensors. You agree to comply with all intellectual property
                        laws and you shall not encumber any interest in, or assert any rights to, any Content.
                        You may not modify, transmit, participate in the sale or transfer of, or create
                        derivative works based on any Content, in whole or in part. However, you may print a
                        single copy of the Content for your own personal use, provided that you maintain any
                        notices contained in the Content, such as all copyright notices, trademark legends, or
                        other proprietary rights notices.
                    </LegalText>

                    <LegalSectionTitle>Trademarks</LegalSectionTitle>
                    <LegalText>
                        The trademarks, service marks, trade names and logos (collectively, the “Trademarks”)
                        used and displayed on our site are registered and unregistered trademarks of ours or
                        our licensors. All page headers, custom graphics, button icons, and scripts are service
                        marks, trademarks and/or trade dress of ours and may not be copied, imitated or used,
                        in whole or in part, in connection with any product or service that is not authorized
                        by us, in any manner that is likely to cause confusion, or in any manner that disparages
                        or discredits us. The Trademarks used and displayed on our site are and shall remain the
                        sole property of us or our licensors. Nothing in these Terms of Use shall be construed as
                        granting, by implication, estoppel or otherwise, any license, ownership right, or right to
                        use any Trademarks used or displayed on our site. The misuse of the Trademarks displayed on
                        our site, or any other Content on our site, is strictly prohibited.
                    </LegalText>

                    <LegalSectionTitle>Links to Third Party Web Sites</LegalSectionTitle>
                    <LegalText>
                        Our site may contain links to third party web sites. Any such links are provided for your
                        convenience only. We do not control those web sites, and we are not responsible for their
                        contents or practices, including their privacy practices. We do not endorse the operators
                        of those sites, nor do we endorse or make any representations with respect to the contents
                        of those sites or any products or services offered on or through those sites.
                    </LegalText>

                    <LegalSectionTitle>Warranty Disclaimer</LegalSectionTitle>
                    <LegalText>
                        Our site and the Content, materials and products on our site are provided "as is" and
                        without warranties of any kind, whether express or implied. Neither we nor any of our
                        affiliates assume any responsibility for the accuracy of any information contained on
                        our site, for any interruptions or errors in accessing our site, or for any viruses or
                        other harmful components contained on our site or the server from which our site is made
                        available. Neither we nor any of our affiliates make any warranties or representations
                        regarding the use of the materials in this site in terms of their correctness, accuracy,
                        adequacy, usefulness, timeliness, reliability or otherwise. NEITHER WE NOR OUR AFFILIATES
                        MAKE, AND WE AND OUR AFFILIATES HEREBY DISCLAIM, ANY AND ALL WARRANTIES OF ANY KIND WITH
                        RESPECT TO OUR SITE, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT OR ANY
                        WARRANTIES ARISING FROM A COURSE OF PERFORMANCE, A COURSE OF DEALING OR TRADE USAGE.
                    </LegalText>

                    <LegalText>
                        UNDER NO CIRCUMSTANCES WILL WE OR OUR AFFILIATES, OR ANY OF OUR OR OUR AFFILIATES’
                        RESPECTIVE OFFICERS, DIRECTORS, MEMBERS, MANAGERS, EMPLOYEES, AGENTS, SUPPLIERS OR
                        SUCCESSORS BE LIABLE TO ANY PERSON FOR ANY DIRECT, SPECIAL, INCIDENTAL, PUNITIVE, INDIRECT
                        OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, LOSS OF PROFITS OR REVENUES, LOST
                        DATA OR INFORMATION, LOSS OF USE OF OUR SITE, BUSINESS INTERRUPTION, LOSS OF BUSINESS
                        REPUTATION OR GOODWILL, COSTS OF SUBSTITUTE SERVICES, OR DOWNTIME COSTS) RELATING TO OUR
                        SITE OR RESULTING FROM ACCESS TO OR OTHER USE OF OUR SITE OR RELIANCE ON ANY INFORMATION
                        PRESENTED ON OUR SITE, EVEN IF WE ARE INFORMED IN ADVANCE OF THE POSSIBILITY OF SUCH
                        DAMAGES AND NOTWITHSTANDING ANY FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY. Some
                        jurisdictions do not allow exclusion of certain warranties or limitations of liability,
                        so the above limitations or exclusions may not apply to you. Our liability in such case
                        will be limited to the greatest extent permitted by law.
                    </LegalText>

                    <LegalSectionTitle>Indemnification</LegalSectionTitle>
                    <LegalText>
                        You agree to indemnify, defend, and hold us and our officers, directors, members,
                        managers, employees, agents, affiliates, suppliers, successors and assigns harmless from
                        and against any and all claims, liabilities, damages, losses and expenses (including
                        without limitation reasonable fees and costs for attorneys and investigations) arising
                        out of, based on, or in connection with your access to or other use of our site.
                    </LegalText>

                    <LegalSectionTitle>Governing Law and Jurisdiction</LegalSectionTitle>
                    <LegalText>
                        These Terms of Use, and all matters arising directly or indirectly from your access to
                        or other use of our site, shall be governed by and construed in accordance with the laws
                        of the State of New York, without regard to its conflict of laws rules. You hereby submit
                        to the exclusive jurisdiction of the state and federal courts located in the State of
                        New York, and waive any jurisdictional, venue, or inconvenient forum objections to such
                        courts. A printed version of these Terms of Use shall be admissible in judicial or
                        administrative proceedings based on or relating to these Terms of Use to the same extent
                        and subject to the same conditions as other business documents and records originally
                        generated and maintained in printed form.
                    </LegalText>

                    <LegalSectionTitle>Severability</LegalSectionTitle>
                    <LegalText>
                        If any provision of these Terms of Use is held to be illegal, invalid or unenforceable,
                        such illegality, invalidity or unenforceability shall apply only to such provision and
                        shall not in any manner affect or render illegal, invalid or unenforceable any other
                        provision of these Terms of Use, and that provision and these Terms of Use generally
                        shall be reformed, construed and enforced so as to most nearly give lawful effect to the
                        intent of the parties as expressed in these Terms of Use.
                    </LegalText>

                    <LegalSectionTitle>Entire Agreement</LegalSectionTitle>
                    <LegalText>
                        These Terms of Use (including the Privacy Notice) constitute the entire agreement
                        between you and us with respect to our site, and supersede all prior or contemporaneous
                        communications and proposals, whether electronic, oral or written, between you and us
                        with respect to our site.
                    </LegalText>

                    <LegalText>
                        Thank you for your cooperation. We hope that you find our site helpful and convenient to
                        use. Questions or comments regarding our site, including any reports of non-functioning
                        links, should be submitted using our email address at{" "}
                        <LegalEmailLink href="mailto:info@clippn.com">info@clippn.com</LegalEmailLink> or via
                        U.S. mail to:
                    </LegalText>

                    <LegalAddress>
                        <div>135 East 57th Street</div>
                        <div>23rd Floor</div>
                        <div>New York, NY 10022</div>
                    </LegalAddress>
            </LegalContainer>
        </LegalPage>
    );
}
